import catalog from '../data/appCatalog.json';

export const { styleCategories, styleOptions, advancedStyleOptions, emoticonStyleOptions, fruitOptions, groomingBreeds, mbtiQuestions, mbtiJobs, appVersion } = catalog;
export const defaultFruitType = fruitOptions[0];
export function orderedStyles(recentNames = []) {
  const newStyles = styleOptions.filter(s => s.isNew);
  const recent = [...new Set(recentNames)].map(name => styleOptions.find(s => s.name === name))
    .filter(s => s && !s.isNew).slice(0, 3);
  const first = new Set([...newStyles, ...recent].map(s => s.name));
  return [...newStyles, ...recent, ...styleOptions.filter(s => !first.has(s.name))];
}
export function stylesForFeature(feature) {
  if (feature === 'advanced_style_transform') return advancedStyleOptions;
  if (feature === 'emoticon_style') return emoticonStyleOptions;
  return styleOptions;
}
export function calculateMbti(answers) {
  if (answers.length !== 12 || answers.some((answer, i) => !mbtiQuestions[i].answers.some(a => a.type === answer))) return null;
  return ['EI', 'SN', 'TF', 'JP'].map(pair => {
    const first = answers.filter(a => a === pair[0]).length;
    const second = answers.filter(a => a === pair[1]).length;
    return first >= second ? pair[0] : pair[1];
  }).join('');
}

// Normalize feed recommendations while preserving server-owned routing codes.
export function resolveStyle(item = {}) {
  const name = item.style === '이모티콘' ? '애니 이모티콘' : item.style;
  for (const [feature, rows] of [['emoticon_style', emoticonStyleOptions], ['advanced_style_transform', advancedStyleOptions], ['style_transform', styleOptions]]) {
    const style = rows.find(s => s.name === name);
    if (style) return { feature, style };
  }
  if (item.feature === 'find_mbti') return { feature: 'find_mbti' };
  return null;
}
